import Image from 'next/image'
import { Headline } from './Headline'
import { Wing } from '@/components/icons/Wing'
import { imageLoader } from '@/loaders/index'

export function Testimonial({
  className = '',
  photo = '',
  company = '',
  name = '',
  text = ''
}) {
  return (
    <div className={`${className} border border-gray p-[30px] bg-white`}>
      <div className="flex items-center pb-[16px] mb-[16px] border-b ">
        <div className="w-[53px] mr-[16px] shrink-0">
          <Image
            src={photo}
            alt={name}
            loader={imageLoader}
          />
        </div>
        <div className="w-full">
          <div className="flex justify-between items-center">
            <Headline tag="h5" weight={800}>{name}</Headline>
            <span className="text-[13px] flex items-center">
              <span className="flex items-center justify-center rounded-[50%] w-[14px] h-[14px] bg-black mr-[6px]">
                <Wing className="scale-[0.8]"/>
              </span>
              Verified
            </span>
          </div>
          <p className="font-accent text-[14px] text-[#828282]">{company}</p>
        </div>
      </div>
      <p className="font-thin">{text}</p>
    </div>
  )
}
